import { useEffect, useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import { sortByKey, sortByNestedKey } from 'helpers/helpers';
import update from 'immutability-helper';
import {
  Dialog,
  ListItem,
  DialogTitle,
  ListItemText,
  DialogContent,
  List,
} from '@material-ui/core';
import { v4 as uuidv4 } from 'uuid';
import { fetchDiets } from 'actions/Diets';
import { openSweetToast } from 'actions/App';
import { fetchMealTypes } from 'actions/MealTypes';
import { addVariant, editVariant, fetchVariant } from 'actions/Variants';
import { useGetCompanyDefaultLanguage } from 'hooks/redux/Translatable/useTranslatableLanguages';

import PromptContent from '../PromptContent';
import FormVariantsView from './FormVariants.view';
import { initialState } from './initialState';
import { validateForm } from './auixiliumFuncionts';

const FormVariantsContainer = ({
  // eslint-disable-next-line no-shadow -- FIXME
  fetchMealTypes,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchDiets,
  // eslint-disable-next-line no-shadow -- FIXME
  fetchVariant,
  mealTypes,
  variant,
  // eslint-disable-next-line no-shadow -- FIXME
  editVariant,
  // eslint-disable-next-line no-shadow -- FIXME
  addVariant,
  // eslint-disable-next-line no-shadow -- FIXME
  openSweetToast,
  diets,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();

  const [state, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);

  const editId = match.params.id;
  const isEdit = location.pathname.includes('edit');
  let initialMealTypes = [];
  const companyDefaultLanguage = useGetCompanyDefaultLanguage();

  const { multinational } = useSelector(
    ({
      Brands: {
        // eslint-disable-next-line no-shadow -- FIXME
        brand: { multinational },
      },
    }) => ({
      multinational,
    })
  );

  useEffect(() => {
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    Promise.all([fetchMealTypes(), fetchDiets()]).then(res => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
      editId &&
        // eslint-disable-next-line promise/prefer-await-to-then, no-shadow -- FIXME
        fetchVariant(editId, { translations: true }).then(variant => {
          const mealTypesAfterFetch = res[0].filter(mealType =>
            variant.mealTypes.includes(mealType['@id'])
          );

          // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
          initialMealTypes = mealTypesAfterFetch.sort(
            (a, b) => a.position - b.position
          );
          setState(prev => ({
            ...prev,
            variant: {
              ...variant,
              mealTypes: mealTypesAfterFetch,
              calories: sortByKey(variant.calories, 'position').map(el => ({
                ...el,
                key: uuidv4(),
              })),
            },
            image: variant.image?.['@id'] || null,
            imageUrl: variant.image?.contentUrl || null,
          }));
          setIsLoading(false);
        });
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
    !isEdit && setIsLoading(false);
  }, []);

  const setCalories = (dragIndex, hoverIndex, dragRow) => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        calories: {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragRow],
          ],
        },
      }),
    }));
  };

  const handleNameChange = e => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        name: { $set: e.target.value },
      }),
    }));
  };

  // eslint-disable-next-line no-shadow -- FIXME
  const handleVariantName = (calorie, variant, e) => {
    calorie.name = e.target.value;
    setState(prev => ({ ...prev, variant }));
  };

  // eslint-disable-next-line no-shadow -- FIXME
  const handleVariantWorkName = (calorie, variant, e) => {
    calorie.workName = e.target.value;
    setState(prev => ({ ...prev, variant }));
  };

  // eslint-disable-next-line no-shadow -- FIXME
  const toggleCalorificActivness = (calorie, variant) => {
    calorie.active = !calorie.active;
    setState(prev => ({ ...prev, variant }));
  };

  // eslint-disable-next-line no-shadow -- FIXME
  const removeRow = (variant, index) => {
    const { calories } = variant;
    calories.splice(index, 1);
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        calories: { $set: calories },
      }),
    }));
  };

  const handleShortNameChange = e => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        shortName: { $set: e.target.value },
      }),
    }));
  };

  const handlePositionChange = e => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        // eslint-disable-next-line radix -- FIXME
        position: { $set: parseInt(e.target.value) },
      }),
    }));
  };

  const handleChangeIntField = e => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        // eslint-disable-next-line radix -- FIXME
        [e.target.name]: { $set: parseInt(e.target.value) },
      }),
    }));
  };

  const handleDiets = e => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        diets: { $set: e.target.value },
      }),
    }));
  };

  const toggleCheckboxState = name => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        [name]: {
          $set: !state.variant?.[name],
        },
      }),
    }));
  };

  const handleToggle = name => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        [name]: { $set: !state.variant[name] },
      }),
    }));
  };

  const handleMealTypes = (e, selected) => {
    // eslint-disable-next-line no-shadow -- FIXME
    const { variant } = state;
    // eslint-disable-next-line no-shadow -- FIXME
    const mealTypes = selected.map(el => el['@id']);

    variant.calories.forEach(calorie => {
      calorie.sizes = calorie.sizes.filter(size =>
        mealTypes.includes(size.mealType)
      );
    });

    setState(prev => ({
      ...prev,
      variant: update(variant, {
        mealTypes: { $set: selected },
      }),
    }));
  };

  const handleDescriptionChange = e => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        description: { $set: e.target.value },
      }),
    }));
  };

  const handleInternalPositionChange = e => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        // eslint-disable-next-line radix -- FIXME
        internalPosition: { $set: parseInt(e.target.value) },
      }),
    }));
  };

  const addCalorie = () => {
    setState(prev => ({
      ...prev,
      variant: update(state.variant, {
        calories: {
          $set: [
            ...state.variant.calories,
            {
              name: '',
              workName: '',
              sizes: [],
              active: true,
              superVariantMealType: [],
              key: uuidv4(),
            },
          ],
        },
      }),
    }));
  };

  const getSizeName = (row, mealTypeId) => {
    const editedVariant = { ...state.variant };
    const calorie = editedVariant.calories[row];
    const editedSize = calorie.sizes.find(size => size.mealType === mealTypeId);

    if (!editedSize) {
      return <button className="variant-sizeButton">+</button>;
    }
    let size = mealTypes
      .find(mealType => mealType['@id'] === mealTypeId)
      // eslint-disable-next-line no-shadow -- FIXME
      .sizes.find(size => size['@id'] === editedSize.size);

    if (typeof size === 'undefined') {
      size = { size: { name: 'BRAK' }, calories: 0 };
    }
    return (
      <button className="variant-sizeFilled">
        {size.size.name} - {size.calories} {t('form.field.variant.kcal')}
      </button>
    );
  };

  const getImage = (stateName, data) => {
    setState(prev => ({
      ...prev,
      [stateName]: data?.['@id'] || null,
      [`${stateName}Url`]: data?.contentUrl || null,
    }));
  };

  const removeImage = stateName => {
    setState(prev => ({
      ...prev,
      [stateName]: null,
      [`${stateName}Url`]: null,
    }));
  };

  const getRowSum = row => {
    let sum = 0;

    row.sizes.forEach(size => {
      mealTypes.forEach(mealType => {
        if (mealType['@id'] === size.mealType) {
          mealType.sizes.forEach(mtSize => {
            if (mtSize['@id'] === size.size) {
              sum += mtSize.calories;
            }
          });
        }
      });
    });

    return `${sum} ${t('form.field.variant.kcal')}`;
  };

  const closeModal = () => {
    setState(prev => ({ ...prev, modal: null }));
  };

  const openModal = (rawSizes, row, mealTypeId) => {
    const sizes = sortByNestedKey(rawSizes, 'size', 'position');

    setState(prev => ({
      ...prev,
      modal: (
        <Dialog open={true} onClose={closeModal}>
          <DialogTitle>
            {t('form.field.variant.dialogTitle.choiceMealSize')}
          </DialogTitle>
          <DialogContent>
            <List>
              {sizes.length > 0 ? (
                sizes.map(size => (
                  <ListItem
                    className="variant-listItem"
                    style={{
                      cursor: 'pointer',
                      textAlign: 'center',
                    }}
                    key={size.id}
                    onClick={() => {
                      const editedVariant = { ...state.variant };
                      const calorie = editedVariant.calories[row];
                      let editedSize = calorie.sizes.find(
                        // eslint-disable-next-line no-shadow -- FIXME
                        size => size.mealType === mealTypeId
                      );
                      if (!editedSize) {
                        editedSize = { mealType: mealTypeId, size: null };
                        calorie.sizes.push(editedSize);
                      }
                      editedSize.size = size['@id'];
                      closeModal();
                    }}
                  >
                    <ListItemText>
                      {size.size.name} - {size.calories}{' '}
                      {t('form.field.variant.kcal')}
                    </ListItemText>
                  </ListItem>
                ))
              ) : (
                <h1>{t('form.field.variant.dialogContent.notExistsSizes')}</h1>
              )}
            </List>
          </DialogContent>
        </Dialog>
      ),
    }));
  };

  const handleSubmit = async () => {
    if (!validateForm(state, t, companyDefaultLanguage)) {
      return;
    }
    const data = {
      ...state.variant,
      image: state.image,
      mealTypes: state.variant.mealTypes.map(mealType => mealType['@id']),
      calories: state.variant.calories.map((calorie, index) => {
        calorie.position = index;
        calorie.superVariantMealType = calorie.superVariantMealType.map(el => ({
          ...el,
          mealType: el.mealType?.['@id'] || el.mealType,
        }));
        return calorie;
      }),
    };

    if (isEdit) {
      try {
        // eslint-disable-next-line no-use-before-define -- FIXME
        if (showWarningModal()) {
          // eslint-disable-next-line no-use-before-define -- FIXME
          await sweetToastPrompt();
        }
        await editVariant(match.params.id, data);
        history.push('/admin/variants');
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-empty -- FIXME
      } catch (err) {}
    } else {
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      addVariant(data).then(() => {
        history.push('/admin/variants');
      });
    }
  };

  const showWarningModal = () =>
    !initialMealTypes.every(initialMealType =>
      state.variant.mealTypes.some(
        stateMealType => stateMealType.id === initialMealType.id
      )
    );

  const sweetToastPrompt = () =>
    new Promise((resolve, reject) => {
      openSweetToast({
        style: { display: 'block' },
        title: t('variants.save.prompt.title'),
        content: <PromptContent />,
        showCancel: true,
        onConfirm: resolve,
        onCancel: reject,
        confirmBtnText: t('common.shared.yes'),
        cancelBtnText: t('common.shared.no'),
      });
    });

  if (isLoading) {
    return null;
  }

  return (
    <FormVariantsView
      state={state}
      setState={setState}
      isEdit={isEdit}
      setCalories={setCalories}
      handleNameChange={handleNameChange}
      handleVariantName={handleVariantName}
      handleVariantWorkName={handleVariantWorkName}
      toggleCalorificActivness={toggleCalorificActivness}
      removeRow={removeRow}
      handleShortNameChange={handleShortNameChange}
      handlePositionChange={handlePositionChange}
      handleChangeIntField={handleChangeIntField}
      handleDiets={handleDiets}
      toggleCheckboxState={toggleCheckboxState}
      handleToggle={handleToggle}
      handleMealTypes={handleMealTypes}
      handleDescriptionChange={handleDescriptionChange}
      handleInternalPositionChange={handleInternalPositionChange}
      addCalorie={addCalorie}
      getSizeName={getSizeName}
      getImage={getImage}
      removeImage={removeImage}
      getRowSum={getRowSum}
      openModal={openModal}
      handleSubmit={handleSubmit}
      mealTypes={mealTypes}
      variant={variant}
      diets={diets}
      multinational={multinational}
    />
  );
};

const mapStateToProps = state => ({
  variant: state.Variants.variant,
  mealTypes: state.MealTypes.mealTypes,
  diets: state.Diets.diets,
});

const mapDispatchToProps = {
  fetchMealTypes,
  fetchDiets,
  addVariant,
  editVariant,
  fetchVariant,
  openSweetToast,
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(FormVariantsContainer)
);
